
  import {Component, Vue} from 'vue-property-decorator';
  import L from 'leaflet';
  import {getMapPoints} from '@/api/map';

  import {getMapFloorByIdAsync} from '@/api/floor';
  import PointContent from '@/components/pointContent.vue';
  import VirtualNavigation from '@/components/VirtualNavigation.vue';
  import {Guid} from 'guid-typescript';
  import SoundWave from '@/components/SoundWave.vue';

  @Component({
    components: {
      PointContent,
      SoundWave,
      VirtualNavigation
    }
  })
  export default class FloorMap extends Vue {
    private cshow = false;
    private pointId: Guid | undefined;
    private contentTitle = '';
    private isNavigation = false;

    private typeItems: any[] = [];
    private isShowSearch = false;
    private searchValue = '';
    private mapUrl = '';
    private baseUrl = Vue.prototype.$appsettings.serverUrl + '/';

    private map: L.Map | undefined;
    private tooltipOptions: L.TooltipOptions = {
      permanent: true,
      direction: 'top',
      offset: L.point([0, -18]),
      opacity: 0.8,
      className: 'custom_tooltip'
    };

    private iconOption: L.IconOptions = {
      popupAnchor: [0, -14],
      iconUrl: require('@/assets/default.png'),
      className: 'custom_marker'
    };

    private markerLayers: L.Marker[] = [];
    private markerGroup: L.Layer | undefined;
    private currentMarker: L.Marker | undefined;
    private currentItem = {};
    private currentTime = 0;
    private duration = 0;
    private timer = 0;
    private audio: HTMLAudioElement | undefined;
    private isPlaying = false;
    private isPause = false;

    private tempRoomId = '';
    private isVirtualNavigation = false;
    private virtualNavigationPop = false;

    private polyline: L.Polyline | undefined;
    private polylineOption: L.PolylineDecorator | undefined;

    get percent() {
      return Math.min(1, this.currentTime / this.duration);
    }

    get color() {
      let color = this.$store.getters.background;
      if (!color) {
        color = '#1eb57a';
      }
      // document.documentElement.style.setProperty('--color', color);
      return color;
    }

    get isNavTop() {
      let isNavTop = this.$store.getters.isShowNav;
      return isNavTop;
    }

    get roomMapColor() {
      let roomMapColor = this.$store.getters.roomMapColor;
      return roomMapColor;
    }

    get roomMapUrl() {
      let roomMapUrl = this.$store.getters.roomMapUrl;
      return roomMapUrl;
    }

    private get roomId() {
      return this.$route.query.roomId;
    }

    public async handlerSearch() {
      await this.getMarkers();
    }

    private async mounted() {
      await this.getRoomName();
    }

    private initMap() {
      this.map = L.map('map', {
        center: [-90, 90],
        zoomControl: false,
        attributionControl: false,
        zoom: 1,
        minZoom: 1,
        maxZoom: 3,
        crs: L.CRS.Simple
      });

      if (this.mapUrl) {
        const url = this.baseUrl + this.mapUrl;
        let img = new Image();
        img.src = url;
        img.onload = () => {
          if (this.map) {
            let southWest = this.map.unproject([0, img.height], this.map.getMaxZoom() - 1);
            let northEast = this.map.unproject([img.width, 0], this.map.getMaxZoom() - 1);
            let bounds = new L.LatLngBounds(southWest, northEast);
            L.imageOverlay(url, bounds).addTo(this.map);
            this.map.setMaxBounds(bounds);
          }
        };

        this.map.on('click', () => {
          this.isShowSearch = false;
          this.searchValue = '';
        });
      }
    }

    private async getRoomName() {
      if (this.roomId) {
        const result = await getMapFloorByIdAsync(this.roomId);
        this.typeItems = [{
          id: result.id,
          explain: result.name
        }];
        this.tempRoomId = result.pointId;
        this.mapUrl = result.mapUrl;
        this.isVirtualNavigation = result.isVirtualNavigation;
        this.initMap();

        setTimeout(() => {
          this.getMarkers();
        }, 500);
      }
    }

    private async getMarkers() {
      this.markerLayers = [];
      this.markerGroup?.remove();
      const result = await getMapPoints(this.searchValue, this.roomId.toString());
      for (let item of result.items) {
        // 判断是否有自定义图标
        let custom_icon = L.icon(this.iconOption);
        if (item.iconUrl) {
          const host = location.host
          custom_icon.options.iconUrl = `http://${host}/${item.iconUrl}`
        }

        if (item.latitude && item.longitude) {
          let marker = L.marker([item.latitude, item.longitude], {
            icon: custom_icon
          });

          if (!item.isHideTip) {
            marker.bindTooltip(item.name, this.tooltipOptions).openTooltip();
          }

          marker.on('click', () => {
            if (this.virtualNavigationPop) {
              this.handlerClickNavigation(item);
            } else {
              this.handlerContentClick(item, marker);
            }
          });

          this.markerLayers.push(marker);
        }
      }

      this.markerGroup = L.layerGroup(this.markerLayers);
      this.map?.addLayer(this.markerGroup);
    }

    private getLines(points: any[]) {
      let latlngs = [];
      for (let obj of points) {
        let latlng = [obj.latitude, obj.longitude];
        latlngs.push(latlng);
      }

      if (this.map) {
        this.polyline = L.polyline(latlngs, {weight: 5}).addTo(this.map);
        this.polylineOption = L.polylineDecorator(this.polyline, {
          patterns: [
            {
              offset: 10, repeat: 50, symbol: L.Symbol.arrowHead({
                pixelSize: 4,  // 箭头大小
                headAngle: 70,  // 角度
                polygon: false,
                pathOptions: {stroke: true, weight: 2, color: '#fff'}
              }),
            },
          ]
        }).addTo(this.map);
      }
    }

    private handlerSearchClick() {
      this.isShowSearch = true;
    }

    private handlerClearSearch() {
      this.searchValue = '';
    }

    private handlerCdClick() {
      if (this.tempRoomId) {
        this.$router.push({
          path: '/floor/index',
          query: {
            roomId: this.tempRoomId
          }
        });
      }
    }

    private close(v: boolean) {
      this.cshow = v;
      this.virtualNavigationPop = v;

      if (this.map && this.polyline && this.polylineOption) {
        this.map.removeLayer(this.polyline);
        this.map.removeLayer(this.polylineOption);
      }
    }

    private handleClickYb() {
      if (this.currentItem && this.currentMarker) {
        this.handlerContentClick(this.currentItem, this.currentMarker);
      }
    }

    private handlerClickNavigation(item: any) {
      (this.$refs.navigation as any).handlerToNavigation(item);
    }

    private handlerContentClick(item: any, marker: any) {
      this.cshow = true;
      this.contentTitle = item.name;
      this.isNavigation = item.isNavigation;
      this.mapUrl = item.mapUrl;
      if (this.pointId !== item.id) {
        this.currentItem = item;
        this.pointId = item.id;
        if (this.timer > 0) {
          clearInterval(this.timer);
          this.isPlaying = false;
          this.isPause = true;
          this.audio?.pause();
          this.currentTime = 0;
          this.duration = 0;
          this.handlerRemoveClass(this.currentMarker);
        }
        this.currentMarker = marker;
      }

      // 点击点位时设置为中心点
      if (this.map && item.latitude && item.longitude) {
        this.map.setView([item.latitude, item.longitude]);
      }
    }

    private handlerAddClass(marker: any) {
      const has = L.DomUtil.hasClass(marker._icon, 'blinking');
      if (!has) {
        L.DomUtil.addClass(marker._icon, 'blinking');
      }
    }

    private handlerRemoveClass(marker: any) {
      if (marker) {
        const has = L.DomUtil.hasClass(marker._icon, 'blinking');
        if (has) {
          L.DomUtil.removeClass(marker._icon, 'blinking');
        }
      }
    }

    private playAudio(audioUrl: string, chineseAudioFile: string) {
      if ((audioUrl || chineseAudioFile)) {
        this.audio = new Audio();
        if (chineseAudioFile) {
          this.audio.src = chineseAudioFile;
        } else {
          this.audio.src = audioUrl;
        }
      }
    }

    private handlerPlay() {
      if (this.audio) {
        const play = this.audio.play();
        this.isPlaying = true;
        this.isPause = false;
        // 点闪烁
        if (this.currentMarker) {
          this.handlerAddClass(this.currentMarker);
        }
        play.then(() => {
          if (this.audio) {
            this.duration = this.audio.duration;
          }
          this.timer = setInterval(() => {
            if (this.audio) {
              this.currentTime = this.audio.currentTime;
              if (this.currentTime === this.duration) {
                clearInterval(this.timer);
                this.isPlaying = false;
                if (this.currentMarker) {
                  this.handlerRemoveClass(this.currentMarker);
                }
              }
            }
          }, 1000);
        });
      }
    }

    private handlerPause() {
      if (this.audio && this.isPlaying) {
        this.audio.pause();
        this.handlerRemoveClass(this.currentMarker);
        this.isPause = true;
        this.isPlaying = false;
        if (this.timer > 0) {
          clearInterval(this.timer);
        }
      }
    }

    private handleClickMoni() {
      this.virtualNavigationPop = true;
    }
  }
